/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { RentalContract } from '../models/rental-contract';

@Injectable({
  providedIn: 'root',
})
export class RentalContractsService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getRentalContracts
   */
  static readonly GetRentalContractsPath = '/api/v1/RentalContracts';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getRentalContracts$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getRentalContracts$Plain$Response(params?: {
    count?: number;
    page?: number;
    sort?: string;
    order?: 'Asc' | 'Desc';
  },
  context?: HttpContext

): Observable<StrictHttpResponse<Array<RentalContract>>> {

    const rb = new RequestBuilder(this.rootUrl, RentalContractsService.GetRentalContractsPath, 'get');
    if (params) {
      rb.query('count', params.count, {});
      rb.query('page', params.page, {});
      rb.query('sort', params.sort, {});
      rb.query('order', params.order, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<RentalContract>>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getRentalContracts$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getRentalContracts$Plain(params?: {
    count?: number;
    page?: number;
    sort?: string;
    order?: 'Asc' | 'Desc';
  },
  context?: HttpContext

): Observable<Array<RentalContract>> {

    return this.getRentalContracts$Plain$Response(params,context).pipe(
      map((r: StrictHttpResponse<Array<RentalContract>>) => r.body as Array<RentalContract>)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getRentalContracts()` instead.
   *
   * This method doesn't expect any request body.
   */
  getRentalContracts$Response(params?: {
    count?: number;
    page?: number;
    sort?: string;
    order?: 'Asc' | 'Desc';
  },
  context?: HttpContext

): Observable<StrictHttpResponse<Array<RentalContract>>> {

    const rb = new RequestBuilder(this.rootUrl, RentalContractsService.GetRentalContractsPath, 'get');
    if (params) {
      rb.query('count', params.count, {});
      rb.query('page', params.page, {});
      rb.query('sort', params.sort, {});
      rb.query('order', params.order, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<RentalContract>>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getRentalContracts$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getRentalContracts(params?: {
    count?: number;
    page?: number;
    sort?: string;
    order?: 'Asc' | 'Desc';
  },
  context?: HttpContext

): Observable<Array<RentalContract>> {

    return this.getRentalContracts$Response(params,context).pipe(
      map((r: StrictHttpResponse<Array<RentalContract>>) => r.body as Array<RentalContract>)
    );
  }

  /**
   * Path part for operation getRentalContract
   */
  static readonly GetRentalContractPath = '/api/v1/RentalContracts/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getRentalContract$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getRentalContract$Plain$Response(params: {
    id: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<RentalContract>> {

    const rb = new RequestBuilder(this.rootUrl, RentalContractsService.GetRentalContractPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<RentalContract>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getRentalContract$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getRentalContract$Plain(params: {
    id: string;
  },
  context?: HttpContext

): Observable<RentalContract> {

    return this.getRentalContract$Plain$Response(params,context).pipe(
      map((r: StrictHttpResponse<RentalContract>) => r.body as RentalContract)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getRentalContract()` instead.
   *
   * This method doesn't expect any request body.
   */
  getRentalContract$Response(params: {
    id: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<RentalContract>> {

    const rb = new RequestBuilder(this.rootUrl, RentalContractsService.GetRentalContractPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<RentalContract>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getRentalContract$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getRentalContract(params: {
    id: string;
  },
  context?: HttpContext

): Observable<RentalContract> {

    return this.getRentalContract$Response(params,context).pipe(
      map((r: StrictHttpResponse<RentalContract>) => r.body as RentalContract)
    );
  }

  /**
   * Path part for operation updateRentalContract
   */
  static readonly UpdateRentalContractPath = '/api/v1/RentalContracts/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateRentalContract$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateRentalContract$Plain$Response(params: {
    id: string;
    body?: RentalContract
  },
  context?: HttpContext

): Observable<StrictHttpResponse<RentalContract>> {

    const rb = new RequestBuilder(this.rootUrl, RentalContractsService.UpdateRentalContractPath, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<RentalContract>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateRentalContract$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateRentalContract$Plain(params: {
    id: string;
    body?: RentalContract
  },
  context?: HttpContext

): Observable<RentalContract> {

    return this.updateRentalContract$Plain$Response(params,context).pipe(
      map((r: StrictHttpResponse<RentalContract>) => r.body as RentalContract)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateRentalContract()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateRentalContract$Response(params: {
    id: string;
    body?: RentalContract
  },
  context?: HttpContext

): Observable<StrictHttpResponse<RentalContract>> {

    const rb = new RequestBuilder(this.rootUrl, RentalContractsService.UpdateRentalContractPath, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<RentalContract>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateRentalContract$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateRentalContract(params: {
    id: string;
    body?: RentalContract
  },
  context?: HttpContext

): Observable<RentalContract> {

    return this.updateRentalContract$Response(params,context).pipe(
      map((r: StrictHttpResponse<RentalContract>) => r.body as RentalContract)
    );
  }

  /**
   * Path part for operation deleteRentalContract
   */
  static readonly DeleteRentalContractPath = '/api/v1/RentalContracts/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteRentalContract$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteRentalContract$Plain$Response(params: {
    id: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<RentalContract>> {

    const rb = new RequestBuilder(this.rootUrl, RentalContractsService.DeleteRentalContractPath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<RentalContract>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteRentalContract$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteRentalContract$Plain(params: {
    id: string;
  },
  context?: HttpContext

): Observable<RentalContract> {

    return this.deleteRentalContract$Plain$Response(params,context).pipe(
      map((r: StrictHttpResponse<RentalContract>) => r.body as RentalContract)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteRentalContract()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteRentalContract$Response(params: {
    id: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<RentalContract>> {

    const rb = new RequestBuilder(this.rootUrl, RentalContractsService.DeleteRentalContractPath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<RentalContract>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteRentalContract$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteRentalContract(params: {
    id: string;
  },
  context?: HttpContext

): Observable<RentalContract> {

    return this.deleteRentalContract$Response(params,context).pipe(
      map((r: StrictHttpResponse<RentalContract>) => r.body as RentalContract)
    );
  }

}
